import angular from "angular";
import Vue from "vue";
import "ngVue";

import dcColorPicker from "./ColorPicker.vue";

export default angular
  .module("directives.colorpicker", [])
  .directive("dcColorPicker", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcColorPicker", dcColorPicker));
    },
  ]);

